import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export function PetTalk({ mood }) {
  const [text, setText] = useState(null);
  useEffect(() => { api.get("/ai/pet-talk").then(({ data }) => setText(data.text)).catch(() => {}); }, [mood]);
  if (!text) return null;
  return (
    <div className="relative mx-auto max-w-xs rounded-2xl bg-white border border-rose-100 shadow-sm px-4 py-2.5 text-sm font-semibold text-slate-700 text-center animate-in fade-in zoom-in-95 duration-500" data-testid="pet-talk">
      <span className="absolute -top-1.5 left-1/2 -translate-x-1/2 w-3 h-3 rotate-45 bg-white border-l border-t border-rose-100" aria-hidden />
      {text}
    </div>
  );
}
